(() => {
  if (customElements.get('gr-monthly-giveaway')) return;
  customElements.define('gr-monthly-giveaway', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-giveaway-copy]').textContent);
      this.dialog = this.querySelector('dialog');
      this.reopen = document.querySelector('[data-giveaway-reopen]');
      this.apiOrigin = new URL(this.dataset.api).origin;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-giveaway-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-giveaway-reopen]');
        if (!link || link.hidden) return;
        event.preventDefault();
        this.reopen = link;
        this.returnFocus = link;
        const navigation = link.closest('.gr-home-header__nav.is-open');
        const toggle = navigation?.closest('header')?.querySelector('.gr-home-header__toggle[aria-expanded="true"]');
        if (toggle) { toggle.click(); this.returnFocus = toggle; }
        this.open(false);
      }, options);
      this.querySelector('[data-giveaway-retry]').addEventListener('click', () => this.open(false), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dismiss(); } }, options);
      this.dialog.addEventListener('submit', event => { if (!event.target.closest('product-form')) return; const form = event.target; this.pendingCart = { variant: String(new FormData(form).get('id')), at: Date.now() }; }, options);
      this.addEventListener('click', event => { const link = event.target.closest('[data-gr-product-link]'); if (link) { const card = link.closest('gr-brand-product'); this.track('product_click', { variant_id: card?.querySelector('[name=id]')?.value || '', product_path: new URL(link.href).pathname }); } }, options);
      this.receive = event => {
        if (!this.frame || event.source !== this.frame.contentWindow || event.origin !== this.apiOrigin || event.data?.giveaway !== this.current?.id) return;
        const d = event.data;
        if (d.type === 'gr-giveaway:height' && Number.isFinite(d.height)) this.frame.style.height = Math.min(1000, Math.max(355, d.height + 2)) + 'px';
        if (d.type === 'gr-giveaway:ready') {
          clearTimeout(this.formTimer);
          this.formReady = true;
          this.querySelector('[data-giveaway-status]').textContent = '';
          if (this.dialog.open) { this.markShown(); this.track('view'); }
        }
        if (d.type === 'gr-giveaway:dismiss') this.dismiss();
        if (d.type === 'gr-giveaway:entered' && d.end === this.current.end && d.month === this.current.month) {
          this.setStored('entered:' + d.giveaway, { end: d.end });
          this.markShown();
          this.showSuccess(d.alreadyEntered, d.discountCode);
          if (!d.alreadyEntered) this.track('entry_saved');
        }
      };
      window.addEventListener('message', this.receive, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'product-form' || !this.pendingCart || String(event.productVariantId) !== this.pendingCart.variant || Date.now() - this.pendingCart.at > 60000) return;
          this.track('add_to_cart', { variant_id: this.pendingCart.variant });
          this.pendingCart = null;
          this.dialog.close();
          document.querySelector('cart-drawer')?.setActiveElement?.(this.reopen || document.querySelector('header a'));
        });
        this.unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, () => { this.pendingCart = null; });
      }
      this.busyObserver = new MutationObserver(() => {
        if (this.observeFrame) return;
        this.observeFrame = requestAnimationFrame(() => { this.observeFrame = null; if (this.waitingForOverlay && !this.blocked()) this.autoOpen(); });
      });
      this.busyObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
      if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
      try { localStorage.removeItem('gr-giveaway:dismissed'); } catch {}
      this.updateReopenLinks();
      document.addEventListener('shopify:section:load', () => this.updateReopenLinks(), options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden && !window.Shopify?.designMode) this.autoOpen(); }, options);
      window.addEventListener('pageshow', event => { if (event.persisted && !window.Shopify?.designMode) this.autoOpen(); }, options);
      if (!window.Shopify?.designMode) this.autoOpen();
      else this.load().catch(() => {});
    }
    disconnectedCallback() { clearTimeout(this.retry); clearTimeout(this.formTimer); this.updateReopenLinks(null); this.openRequest = (this.openRequest || 0) + 1; this.abort?.abort(); this.unsubscribeCart?.(); this.unsubscribeError?.(); this.busyObserver?.disconnect(); cancelAnimationFrame(this.observeFrame); this.ready = false; }
    updateReopenLinks(giveaway = this.activeGiveaway) {
      clearTimeout(this.linksTimer);
      this.activeGiveaway = giveaway?.status === 'open' && giveaway.end > Date.now() ? giveaway : null;
      document.querySelectorAll('[data-giveaway-reopen]').forEach(link => { link.hidden = !this.activeGiveaway; });
      if (this.activeGiveaway) this.linksTimer = setTimeout(() => { this.updateReopenLinks(); if (!this.activeGiveaway) this.autoOpen(); }, Math.min(this.activeGiveaway.end - Date.now() + 1, 2147483647));
    }
    stored(key) { try { return JSON.parse(localStorage.getItem('gr-giveaway:' + key) || 'null'); } catch { return null; } }
    setStored(key, value) { try { localStorage.setItem('gr-giveaway:' + key, JSON.stringify(value)); } catch {} }
    shown(id) {
      if (this.shownId === id) return true;
      try { if (document.cookie.split('; ').includes('gr_giveaway_session_v2=' + encodeURIComponent(id))) return true; } catch {}
      try { return sessionStorage.getItem('gr-giveaway:shown-session-v2') === id; } catch { return false; }
    }
    markShown() {
      if (this.current?.status !== 'open') return;
      const id = this.current.id;
      this.shownId = id;
      try { document.cookie = 'gr_giveaway_session_v2=' + encodeURIComponent(id) + '; Path=/; SameSite=Lax; Secure'; } catch {}
      try { sessionStorage.setItem('gr-giveaway:shown-session-v2', id); } catch {}
    }
    blocked() { return !!document.querySelector('cart-drawer.active, cart-drawer[open], .gr-mini-cart[open], quick-add-modal[open], product-modal[open], modal-dialog[open], dialog[open]:not(.gr-giveaway), details[open].search-modal, .gr-search-overlay[open]') || document.visibilityState === 'hidden'; }
    async load() {
      try {
        const r = await fetch(this.dataset.api + '/current', { cache: 'no-store', credentials: 'omit', signal: AbortSignal.timeout(15000) });
        if (!r.ok) throw Error('Unavailable');
        const data = await r.json();
        if (data.status === 'open' && typeof data.id === 'string' && Number.isFinite(data.end) && data.end > Date.now()) { this.updateReopenLinks(data); return data; }
        this.updateReopenLinks(null);
        if (data.status === 'closed') return { status: 'closed' };
        throw Error('Invalid giveaway status');
      } catch (error) { this.updateReopenLinks(null); throw error; }
    }
    async autoOpen() {
      if (!this.isConnected || window.Shopify?.designMode || this.autoChecking || this.opening || (this.dialog.open && this.current?.status === 'open')) return;
      clearTimeout(this.retry);
      this.autoChecking = true;
      this.waitingForOverlay = false;
      try {
        const g = await this.load();
        if (!this.isConnected) return;
        if (g.status !== 'open') { this.refreshLater(); return; }
        if (this.stored('entered:' + g.id)?.end > Date.now() || this.shown(g.id)) return;
        if (this.blocked()) { this.waitingForOverlay = true; this.retry = setTimeout(() => this.autoOpen(), 2000); return; }
        await this.open(true, g);
      } catch { this.refreshLater(); }
      finally { this.autoChecking = false; }
    }
    refreshLater() { clearTimeout(this.retry); if (!window.Shopify?.designMode) this.retry = setTimeout(() => this.autoOpen(), 30000); }
    async open(automatic, loaded) {
      if (this.blocked() || this.opening || (this.dialog.open && this.current?.status === 'open')) return;
      this.opening = true;
      this.automatic = automatic;
      if (!this.dialog.open && !this.returnFocus) this.returnFocus = document.activeElement;
      const request = this.openRequest = (this.openRequest || 0) + 1;
      if (!automatic && !loaded) { this.current = { status: 'loading' }; this.render(); if (!this.dialog.open) this.dialog.showModal(); }
      try {
        const current = loaded || await this.load();
        if (request !== this.openRequest) return;
        this.current = current;
        if (this.blocked()) { if (automatic) this.retry = setTimeout(() => this.autoOpen(), 2000); return; }
        this.render();
        if (!this.dialog.open) this.dialog.showModal();
        if (this.current.status !== 'open') this.refreshLater();
        this.querySelector('[data-giveaway-success]:not([hidden]) h2, #GRGiveawayHeading')?.focus();
      } catch { if (request !== this.openRequest) return; this.current = { status: 'error' }; if (!automatic) { this.render(); if (!this.dialog.open) this.dialog.showModal(); } this.refreshLater(); }
      finally { if (request === this.openRequest) this.opening = false; }
    }
    render() {
      this.querySelector('[data-giveaway-success]').hidden = true;
      this.querySelector('[data-giveaway-entry]').hidden = false;
      this.querySelector('[data-giveaway-form]').replaceChildren();
      clearTimeout(this.formTimer);
      this.formReady = false;
      this.frame = null;
      const g = this.current, open = g.status === 'open';
      this.querySelector('#GRGiveawayHeading').textContent = open ? g.headline : g.status === 'error' ? this.copy.unavailableTitle : g.status === 'loading' ? this.copy.title : this.copy.closed;
      this.querySelector('[data-giveaway-status]').textContent = open ? this.copy.formLoading : g.status === 'error' ? this.copy.unavailable : g.status === 'loading' ? this.copy.loading : this.copy.closedDetail;
      this.querySelector('[data-giveaway-retry]').hidden = !['error', 'closed'].includes(g.status);
      for (const attr of ['art', 'deck', 'dates', 'rules', 'instructions']) this.querySelector('[data-giveaway-' + attr + ']').hidden = !open;
      this.querySelector('[data-giveaway-closed-continue]').hidden = open;
      if (!open) return;
      const image = this.querySelector('[data-giveaway-photo]');
      const photoURL = new URL(g.photo);
      if (photoURL.origin === this.apiOrigin) image.src = photoURL.href;
      image.alt = g.deckName;
      this.querySelector('[data-giveaway-deck]').textContent = [g.deckName, g.deckSize].filter(Boolean).join(' — ');
      const dates = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
      this.querySelector('[data-giveaway-dates]').textContent = dates.format(g.start) + ' – ' + dates.format(g.end);
      const rulesURL = new URL(g.rulesUrl, location.origin);
      if (rulesURL.protocol === 'https:') this.querySelector('[data-giveaway-rules]').href = rulesURL.href;
      if (this.stored('entered:' + g.id)?.end > Date.now()) { this.showSuccess(false); return; }
      this.frame = document.createElement('iframe');
      this.frame.title = this.copy.formTitle;
      this.frame.referrerPolicy = 'no-referrer';
      const url = new URL(this.dataset.api + '/' + encodeURIComponent(g.id) + '/form');
      url.searchParams.set('parent', location.origin);
      if (this.dataset.formFont) url.searchParams.set('font', this.dataset.formFont);
      this.frame.src = url.href;
      this.querySelector('[data-giveaway-form]').append(this.frame);
      this.formTimer = setTimeout(() => {
        if (this.formReady || this.current?.id !== g.id) return;
        this.current = { status: 'error' };
        this.render();
        if (this.automatic) this.dialog.close();
        this.refreshLater();
      }, 20000);
    }
    showSuccess(already, discount) {
      this.querySelector('[data-giveaway-entry]').hidden = true;
      this.querySelector('[data-giveaway-success]').hidden = false;
      this.querySelector('[data-giveaway-confirmation]').textContent = already ? this.copy.alreadyEntered : this.copy.enteredDetail;
      const code = this.querySelector('[data-giveaway-discount]'); code.hidden = !discount; code.querySelector('strong').textContent = typeof discount === 'string' ? discount.slice(0, 80) : '';
      this.querySelector('[data-giveaway-form]').replaceChildren(); this.frame = null;
      clearTimeout(this.formTimer);
      customElements.get('gr-brand-product')?.alignRows?.();
      if (this.dialog.open) { this.dialog.scrollTop = 0; this.querySelector('[data-giveaway-success] h2').focus(); }
    }
    dismiss() {
      this.openRequest = (this.openRequest || 0) + 1;
      this.opening = false;
      if (this.formReady) this.markShown();
      clearTimeout(this.retry);
      clearTimeout(this.formTimer);
      this.dialog.close();
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      this.returnFocus = null;
      if (!this.formReady && !this.stored('entered:' + this.current?.id)?.end) this.refreshLater();
    }
    track(action, data = {}) {
      if (!this.current?.month || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || typeof window.Shopify?.analytics?.publish !== 'function') return;
      window.Shopify.analytics.publish('gr_giveaway:' + action, { giveaway_month: this.current.month, ...data });
    }
  });
})();
